export * from './manifest.service';
export * from './manifestCommandBuilder.service';
export * from './IManifestCoordinates';
export * from './artifact/artifact.component';
export * from './delete/delete.controller';
export * from './edit/editManifestWizard.controller';
export * from './rollout/pause.controller';
export * from './rollout/undo.controller';
export * from './scale/scale.controller';
export * from './status/condition.component';
export * from './status/status.component';
export * from './wizard/basicSettings.component';
export * from './wizard/manifestEntry.component';
export * from './wizard/manifestWizard.controller';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/kubernetes/src/v2/manifest/index.ts